import React from 'react'
import { DigitalPresenceType } from 'scenes/Dashboard/data/digitalPresences/types'
import { insertItem } from 'utils-next/arrays'
import { connect, FormProps } from 'utils-next/forms'

import { Typography } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

import AddItemButton from '../../../../../AddItemButton'
import { OrganizationFormValues } from '../../OrganizationDetailsEdit.models'
import styles from '../FormSection.styles'
import Attachment from './Attachment'

type AttachmentListProps = WithStyles<typeof styles> & { formik: FormProps<OrganizationFormValues> }

function AttachmentList({
  classes,
  formik: {
    setFieldValue,
    values: { attachmentsValues },
  },
}: AttachmentListProps) {
  const buildNewAttachment = () => ({ id: undefined, label: '', value: null, type: DigitalPresenceType.documentUrl })

  const onAddAttachmentClick = () => {
    setFieldValue('attachmentsValues', insertItem(attachmentsValues, buildNewAttachment()))
  }

  return (
    <div className={classes.sectionContainer}>
      <Typography variant="h6">Attachments</Typography>

      {attachmentsValues.map((attachment, idx) => {
        if (attachment.toDelete) {
          return null
        }

        return <Attachment attachment={attachment} className={classes.sectionItem} index={idx} key={idx} />
      })}

      <AddItemButton label="Add attachment" onClick={onAddAttachmentClick}>
        Add attachment
      </AddItemButton>
    </div>
  )
}

export default connect<Record<string, unknown>, OrganizationFormValues>(withStyles(styles)(AttachmentList))
